import React from "react";
import Select from "react-select";
import { useController, Controller } from "react-hook-form";
import _ from "lodash";
export const ReactSelectField = React.forwardRef((props, ref) => {
  const {
    isDisabled = false,
    title,
    style,
    errors,
    defaultValue,
    onChange,
    isMulti = false,
    capitalize = true,
    menuPlacement,
    isHighLight = false,
    ellipses,
    showMenuOnTop = false,
    maxMenuHeight,
    placeholderHeight = false,
    uniqueKey,
    ...others
  } = props;
  const { field } = useController(props);
  let err = _.get(errors, props.name);
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: !isMulti ? 35 : "100%",
      minHeight: props.minHeight ? props.minHeight : 35,
      maxHeight: "100%",
      boxShadow: "none",
      border: props.rules && err && "1px solid #dc2626",
      backgroundColor: props?.backgroundColor ? props?.backgroundColor : "",
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 50,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const getOptionLabel = (e) => {
    if (props.getOptionLabel) {
      return props.getOptionLabel(e);
    } else {
      return e[props.showLabel || "label"];
    }
  };

  return (
    <>
      <div
        className={`relative bg-white text-gray-500 rounded text-left ${
          isDisabled && " cursor-not-allowed "
        }`}
      >
        <div
          className={`pointer-events-none font-normal mb-2 ${
            props?.rules && err ? "text-red-600" : "text-gray-600"
          }`}
        >
          {title}
          {props?.rules?.required?.value === true && (
            <span className="text-red-500 p-2">*</span>
          )}
        </div>
        <Controller
          name={props?.name}
          rules={props?.rules}
          control={props?.control}
          defaultValue={defaultValue}
          render={({ field: { onChange } }) => (
            <Select
              {...field}
              ref={field.ref}
              menuPortalTarget={showMenuOnTop && document.body}
              maxMenuHeight={maxMenuHeight}
              isLoading={props.isLoading || false}
              noOptionsMessage={() => null}
              getOptionLabel={getOptionLabel}
              styles={customStyles ? customStyles : style}
              isSearchable={true}
              options={props?.optionData}
              placeholder={props?.placeholder ? props?.placeholder : ""}
              menuPlacement={menuPlacement || "auto"}
              isClearable={true}
              onChange={(val, action) => {
                if (uniqueKey) {
                  if (isMulti) {
                    onChange(val.map((obj) => obj?.[uniqueKey]));
                  } else {
                    onChange(val?.[uniqueKey]);
                  }
                } else {
                  onChange(val);
                }
              }}
              value={
                uniqueKey
                  ? field.value && isMulti
                    ? props?.optionData?.filter((obj) =>
                        field?.value.includes(obj?.[uniqueKey])
                      )
                    : field?.value
                    ? props?.optionData?.find(
                        (v, k) => v?.[uniqueKey] == field?.value
                      )
                    : null
                  : field.value
              }
              onBlur={(e) => {
                field.onBlur(e);
              }}
              isDisabled={isDisabled ? isDisabled : false}
              getOptionValue={(option) => option[props.showLabel || "label"]} // changes here!!!
              isOptionDisabled={(option) => option.disabled}
              isMulti={isMulti}
              {...others}
            />
          )}
        />
      </div>

      {props.rules && err && props.rules && err?.message ? (
        <p className=" text-xs text-red-600 h-3" id="email-error">
          {props.rules && err && props.rules && err?.message}
        </p>
      ) : (
        ""
      )}
    </>
  );
});
export const SimpleReactSelectField = React.forwardRef((props, ref) => {
  const {
    isDisabled = false,
    title,
    style,
    isMulti = false,
    capitalize = true,
    menuPlacement,
    isHighLight = false,
    ellipses,
    showMenuOnTop = false,
    maxMenuHeight,
    placeholderHeight = false,
    ...others
  } = props;
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: !isMulti ? 35 : "100%",
      minHeight: props.minHeight ? props.minHeight : 35,
      maxHeight: "100%",
      boxShadow: "none",
      background: isHighLight ? "#feffd7" : isDisabled ? "#f3f4f6" : "",
      // border: props.rules && err && "1px solid #dc2626",
      backgroundColor: props?.backgroundColor ? props?.backgroundColor : "",
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 50,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const getOptionLabel = (e) => {
    if (props.getOptionLabel) {
      return props.getOptionLabel(e);
    } else {
      return e[props.showLabel || "label"];
    }
  };

  return (
    <>
      <div
        className={`relative bg-white text-gray-500 rounded text-left ${
          isDisabled && " cursor-not-allowed "
        }`}
      >
        <div className="text-black">{title} </div>
        <Select
          {...others}
          menuPortalTarget={showMenuOnTop && document.body}
          maxMenuHeight={maxMenuHeight}
          isLoading={props.isLoading || false}
          noOptionsMessage={() => null}
          getOptionLabel={getOptionLabel}
          styles={customStyles ? customStyles : style}
          isSearchable={true}
          options={props?.optionData}
          placeholder={props?.placeholder ? props?.placeholder : ""}
          menuPlacement={menuPlacement || "auto"}
          isClearable={true}
          isDisabled={isDisabled ? isDisabled : false}
          getOptionValue={(option) => option[props.showLabel || "label"]} // changes here!!!
          isOptionDisabled={(option) => option.disabled}
          isMulti={isMulti}
          {...others}
        />
      </div>
    </>
  );
});
